var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 39,
    viewBox: "0 0 23 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48511 17.247C8.66333 17.247 12.2244 8.89214 15.854 10.0563C19.4835 11.1521 14.0734 17.247 9.48511 17.247Z",
    fill: "#4FBFC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89537 18.343C9.89537 18.343 5.92339 13.4123 2.0199 14.508C-1.88359 15.6722 2.97865 21.2878 9.89537 18.343Z",
    fill: "#4FBFC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7318 13.4122C8.7318 13.4122 14.6213 3.27683 12.0874 0.87995C7.70458 -3.43443 2.1575 9.30329 8.7318 13.4122Z",
    fill: "#4FBFC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.593 36.4226L9.96419 38.3401C7.56731 38.888 5.10194 37.5868 4.14319 35.3269L0.239691 25.8763C-0.513614 24.0273 0.582115 21.9728 2.49962 21.562L18.1136 18.0694C20.0311 17.6585 21.8801 19.0281 22.0171 21.0141L22.4964 31.218C22.6334 33.6833 20.9898 35.8747 18.593 36.4226Z",
    fill: "#07285D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4428 20.4662C10.4428 20.4662 7.7035 12.1799 8.73073 8.27637",
    stroke: "#07285D",
    strokeWidth: 1.41783,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon);
export default __webpack_public_path__ + "static/media/PlantIcon.096c4a18f5abeec6e0a52f1d31cd4193.svg";
export { ForwardRef as ReactComponent };